import { operatorLabels } from "./locales/ru";
import React from "react";
import { OperatorSelectorProps } from "react-querybuilder";
import Select from "react-select";
import { NoOptionsMessage, resolveFieldPath } from "./utils";

export default function OperatorSelector(props: OperatorSelectorProps) {
    // @ts-ignore
    let fieldData = resolveFieldPath(props.schema.fields, props.field)?.at(-1);

    if (!fieldData) return null;

    // @ts-ignore
    const operatorOptions = fieldData.predicates.map((op) => ({
        value: op,
        label: operatorLabels[op]?.label || op
    }));

    const selectedOption = operatorOptions.find(
        (option) => option.value === props.value
    );

    return (
        <Select
            className="form-control-select"
            classNamePrefix="react-select"
            options={operatorOptions}
            value={selectedOption}
            components={{ NoOptionsMessage }}
            onChange={(option: any) => props.handleOnChange(option.value)}
            styles={{
                control: (base: any) => ({
                    ...base,
                    minHeight: '38px',
                    height: '38px',
                }),
                valueContainer: (base: any) => ({
                    ...base,
                    height: '38px',
                    padding: '0 8px'
                }),
                indicatorsContainer: (base: any) => ({
                    ...base,
                    height: '38px'
                }),
                menu: (base: any) => ({
                    ...base,
                    width: 'max-content',
                    minWidth: '100%'
                }),
                option: (base: any) => ({
                    ...base,
                    whiteSpace: 'nowrap'
                })
            }}
        />
    );
}
